import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { TarjetasListComponent } from './tarjetas-list.component';
import { TarjetasService } from './tarjetas.service';
import { ITarjeta } from './tarjeta';
// import * as myGlobals from './../global';
import { Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorValidator } from '../services/http-error-validator';

@Component({
  selector: 'pm-tarjetas',
  templateUrl: './tarjetas.component.html',
  styleUrls: ['./tarjetas.component.sass']
})
export class TarjetasComponent implements OnInit, OnDestroy, AfterViewInit {
  tarjetas: ITarjeta[] = [];
  errorMessage = '';
  currentPg = 1;

  constructor(
    public service: TarjetasService,
    private parent: TarjetasListComponent,
    // private router: Router,
    private spinnerService: NgxSpinnerService,
    private httpErrorValidator: HttpErrorValidator
  ) {}

  ngAfterViewInit() {
    // $('#menu-catalogos').click();
    $('a[rel=marca-tarjeta]').addClass('selected');
  }

  newTarjeta(): void {
    this.parent.showEditTarjeta = false;
    this.parent.showTarjetas = false;
    this.parent.showAddTarjeta = true;
  }

  ngOnInit(): void {
    this.service
      .getTarjetas()
      .subscribe(res => (this.tarjetas = res), err => this.httpErrorValidator.validateError(err));
    this.spinner();
  }

  edit(elemento, index: number) {
    this.parent.editnumber = elemento.tarjetas[index].id;
    this.parent.showTarjetas = false;
    this.parent.showAddTarjeta = false;
    this.parent.showEditTarjeta = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  public ngOnDestroy(): void {
    $('a[rel=marca-tarjeta]').removeClass('selected');
  }
}
